import React from "react"
import * as Components from "../components/components"
import { EventBus } from "../eventbus"
import { RechnungstextView } from "./RechnungstextView"
import { useTranslation } from "react-i18next"
import { useStoreRechnung } from "../store"

export function RechnungstexteView() {
    const { t } = useTranslation()
    const { rechnungstexte } = useStoreRechnung("rechnungstexte")

    const onAddClicked = () => {
        EventBus.instance.emit("addRechnungstext")
    }

    return (
        <Components.Collapsible title={t("rechnung.rechnungstexte.title")} collapsed={true}>
            {rechnungstexte.map((rt, idx) => (
                <RechnungstextView key={idx} index={idx} rechnungstext={rt} t={t} />
            ))}

            <Components.Row>
                <Components.Col align={Components.Align.RIGHT}>
                    <Components.Button style={Components.ButtonStyle.SECONDARY} label={t("rechnung.rechnungstexte.textHinzufuegen")} onClick={onAddClicked} />
                </Components.Col>
            </Components.Row>
        </Components.Collapsible>
    )
}
